import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PROMOTED_PETITION_SIGNER_RECEIPT_WELCOME_EMAIL_PROMOTION_COUNT = createFcmDetails(
	'promoted_petition_signer_receipt_welcome_email_promotion_count',
	{
		owner: 'Site Platform',
		context: 'comms stack',
		import: false,
		description:
			'Defines the number of promoted petitions that should be included in the footer of the signature receipt welcome email',
	},
);
